module.exports = __webpack_public_path__ + "img/ihidv.20722d85.svg";